module.exports = __webpack_public_path__ + "5cc3aae674ea3b199313b3b83bd795bc.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Regular.woff
// module id = 365
// module chunks = 0